module.exports = __webpack_public_path__ + "static/media/DBMockup.ad6bd022.png";